import { render, staticRenderFns } from "./BulkAssistantList.vue?vue&type=template&id=28f7976d&scoped=true&"
import script from "./BulkAssistantList.vue?vue&type=script&lang=js&"
export * from "./BulkAssistantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7976d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f7976d')) {
      api.createRecord('28f7976d', component.options)
    } else {
      api.reload('28f7976d', component.options)
    }
    module.hot.accept("./BulkAssistantList.vue?vue&type=template&id=28f7976d&scoped=true&", function () {
      api.rerender('28f7976d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/BulkAssistant/BulkAssistantList.vue"
export default component.exports